// extracted by mini-css-extract-plugin
export default {"cadastroForm":"PessoaForm_cadastroForm__RZ8JI"};